

import {
    AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
    Paper, Badge, Drawer, Divider, Switch, FormControlLabel
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu"; // ← Add this import
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSidebar } from "../../context/SidebarContext";


const Foodandbevaragenavbar = ({ onMenuToggle }) => { // ← Accept prop from parent    const navigate = useNavigate();
    const [showContainer, setShowContainer] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [cartItems, setCartItems] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isOnline, setIsOnline] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const navigate = useNavigate();
    const { toggleSidebar, sidebarOpen } = useSidebar(); // ← Add sidebarOpen


    // 🔥 Detect mobile screen
    const isMobile = useMediaQuery('(max-width:600px)');
    const isBelow992 = useMediaQuery('(max-width:991px)'); // ← Add this
    const isAbove900 = useMediaQuery('(min-width:992px)'); // ← And this
    // ✅ Create a ref for the dropdown container
    const dropdownRef = useRef(null);
    const accountButtonRef = useRef(null);


    // ✅ Get saved online/offline status
    useEffect(() => {
        const savedStatus = localStorage.getItem("isOnline");
        if (savedStatus !== null) {
            setIsOnline(savedStatus === "true");
        }
    }, []);

    // ✅ Listen for cart update events
    useEffect(() => {
        const handleCartUpdate = () => {
            setRefresh(prev => prev + 1);
        };

        // Listen for cart update events
        window.addEventListener('cartUpdated', handleCartUpdate);

        // Cleanup
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, []);

    // ✅ Click outside listener
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close dropdown if clicked outside of both dropdown and account button
            if (
                showContainer &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                accountButtonRef.current &&
                !accountButtonRef.current.contains(event.target)
            ) {
                setShowContainer(false);
            }
        };

        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showContainer]);

    // ✅ Logout functionality
    const handleLogout = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            await axios.post(
                "https://backend.maamaas.com/food/api/auth/logout",
                {},
                { headers: { Authorization: `Bearer ${authToken}` } }
            );
        } catch (error) {
            //console.error("❌ Logout API failed:", error);
        } finally {
            localStorage.removeItem("authToken");
            localStorage.removeItem("vendorId");
            setShowContainer(false);
            setDrawerOpen(false);
            navigate("/");
        }
    };

    // ✅ Fetch all cart items (no orderType filter)
    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/count/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            let items = [];
            let count = 0;

            if (Array.isArray(response.data.cartItems)) {
                items = response.data.cartItems;
                count = items.length;
            } else if (typeof response.data.cartItemsCount === "number") {
                count = response.data.cartItemsCount;
            } else if (typeof response.data === "number") {
                count = response.data;
            }

            setCartItems(items);
            setCartCount(count);
        } catch (error) {
            //console.error("Error fetching cart data:", error);
        }
    };

    // ✅ Fetch restaurant status
    const fetchVendorStatus = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data && typeof response.data.online === "boolean") {
                setIsOnline(response.data.online);
            }
        } catch (error) {
            //console.error("Error fetching vendor status:", error);
        }
    };

    // ✅ Toggle restaurant open/close
    const handleToggleStatus = async (event) => {
        const newStatus = event.target.checked;
        setIsOnline(newStatus);

        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) {
            alert("Vendor ID missing!");
            return;
        }

        localStorage.setItem("isOnline", newStatus);

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { online: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );




        } catch (error) {
            //console.error("Error updating vendor status:", error);

            // ❌ Show backend error message if available
            if (error.response) {
                alert(
                    `Error: Failed to update status!\n\n` +
                    JSON.stringify(error.response.data, null, 2)
                );
            } else {
                alert("Network or server error: " + error.message);
            }
        }
    };

    // ✅ FIXED: Add refresh dependency to refetch cart data when refresh changes
    // useEffect(() => {
    //     fetchCartData();
    //     fetchVendorStatus();
    // }, [refresh]); // ← This is the key fix

    const toggleDrawer = (open) => () => setDrawerOpen(open);


    const DrawerContent = (
        <Box sx={{ width: 250, padding: 2 }} role="presentation">
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>
            <Divider />
        </Box>
    );

    // ✅ Handle account button click
    const handleAccountClick = () => {
        setShowContainer(!showContainer);
    };

    // ✅ Handle menu item click
    const handleMenuItemClick = (action) => {
        setShowContainer(false);
        if (action === "subscription") {
            navigate("/landingpagesubscription");
        } else if (action === "logout") {
            handleLogout();
        }
    };

    // ✅ Handle hamburger menu click
    const handleHamburgerClick = () => {
        if (onMenuToggle) {
            onMenuToggle(); // Call parent function to toggle sidebar
        }
    };


    return (
        <>
            <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: (theme) => theme.zIndex.drawer - 1000, }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                    {/* Left Side - Hamburger Menu + Logo */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {/* Hamburger Menu Icon - Only show below 992px */}
                        {isBelow992 && (
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                onClick={toggleSidebar}
                                sx={{
                                    color: "#fff",
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                    }
                                }}
                            >
                                <MenuIcon fontSize="large" />
                            </IconButton>
                        )}

                        {/* Logo */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: "bold",
                                color: "#fff",
                                fontSize: "26px",
                                cursor: "pointer",
                                marginLeft: isBelow992 ? 1 : 0
                            }}
                            onClick={() => navigate("/fooddashboard")}
                        >
                            MAAMAA'S
                        </Typography>
                    </Box>

                    {/* Right Side */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>

                        {/* User Profile Button */}
                        <IconButton
                            ref={accountButtonRef}
                            onClick={handleAccountClick}
                            sx={{ color: "white" }}
                        >
                            <AccountCircleIcon fontSize="large" />
                        </IconButton>
                    </Box>
                </Toolbar>

                {/* Account Dropdown */}
                {showContainer && (
                    <Paper
                        ref={dropdownRef}
                        sx={{
                            position: "absolute",
                            top: "60px",
                            right: "10px",
                            width: "120px",
                            backgroundColor: "white",
                            boxShadow: 3,
                            borderRadius: "8px",
                            zIndex: 1000
                        }}
                    >
                        <MenuItem onClick={() => handleMenuItemClick("subscription")}>
                            Subscription
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClick("logout")}>
                            Logout
                        </MenuItem>
                    </Paper>
                )}
            </AppBar>
        </>
    );
};

export default Foodandbevaragenavbar;




